export class AgentSetting {
  idAgentSetting: number | null;
  idAgent: number | null;
  settingKey: string;
  defaultValue: string;

  constructor(
    idAgentSetting: number | null,
    idAgent: number | null,
    settingKey: string,
    defaultValue: string
  ) {
    this.idAgentSetting = idAgentSetting;
    this.idAgent = idAgent;
    this.settingKey = settingKey;
    this.defaultValue = defaultValue;
  }

  static fromRaw(raw: any): AgentSetting {
    return new AgentSetting(
      raw.idAgentSetting ?? null,
      raw.idAgent ?? null,
      String(raw.settingKey),
      String(raw.defaultValue)
    );
  }

  clone(): AgentSetting {
    return new AgentSetting(
      this.idAgentSetting,
      this.idAgent,
      this.settingKey,
      this.defaultValue
    );
  }

  toPayload(): any {
    const payload: any = {
      settingKey: this.settingKey,
      defaultValue: this.defaultValue,
    };

    if (this.idAgentSetting !== null) {
      payload.idAgentSetting = this.idAgentSetting;
    }

    return payload;
  }
}
